import React from "react";
import { TimePicker } from "antd";
import moment from "moment";
import { CustomFormItemInputWithBorder } from "../Form";

const format = "HH:mm";
class TimerPicker extends React.Component {
  render() {
    const {
      getFieldDecorator,
      title,
      decodator,
      value,
      required,
      disabled,
      Duracion,
      allowClear,
      placeholder,
    } = this.props;

    // console.log("daySelected", daySelected);

    return (
      <div>
        <CustomFormItemInputWithBorder
          labelCol={{
            xs: { span: 24 },
            sm: { span: 24 },
            lg: { span: 24 },
            xl: { span: 24 },
          }}
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 24 },
            lg: { span: 24 },
            xl: { span: 24 },
          }}
          label={title}
        >
          {getFieldDecorator(decodator, {
            initialValue: value || undefined,
            rules: [
              {
                required,
                message: ".",
              },
            ],
          })(
            <TimePicker
              style={{ width: "100%" }}
              disabled={disabled}
              defaultValue={moment("00:00", format)}
              format={format}
              Duracion={Duracion}
              allowClear={allowClear}
              placeholder={placeholder}
            />
          )}
        </CustomFormItemInputWithBorder>
      </div>
    );
  }
}

export default TimerPicker;
